var map = {
	"./0.png": 3859,
	"./01.png": 7442,
	"./02.png": 3529,
	"./04.png": 3151,
	"./07.png": 8660,
	"./08.png": 3955,
	"./09.png": 8746,
	"./20.png": 8709,
	"./22.png": 9927,
	"./24.png": 3025,
	"./27.png": 4042,
	"./30.png": 5082,
	"./31.png": 9187,
	"./33.png": 6193,
	"./34.png": 3102,
	"./35.png": 1943,
	"./36.png": 2940,
	"./41.png": 2766,
	"./42.png": 4869,
	"./43.png": 2604,
	"./44.png": 8851,
	"./45.png": 4746,
	"./47.png": 1992,
	"./48.png": 1839,
	"./53.png": 4039,
	"./54.png": 1896,
	"./55.png": 5406,
	"./58.png": 1588,
	"./60.png": 529,
	"./61.png": 6312,
	"./62.png": 1587,
	"./63.png": 362,
	"./64.png": 6869,
	"./65.png": 1420,
	"./66.png": 1479,
	"./67.png": 9518,
	"./73.png": 8205,
	"./74.png": 6642,
	"./75.png": 1995,
	"./76.png": 6960,
	"./77.png": 1785,
	"./78.png": 2894,
	"./79.png": 4231,
	"./80.png": 5491,
	"./81.png": 6634,
	"./82.png": 5617,
	"./83.png": 1000,
	"./84.png": 2519,
	"./85.png": 9502,
	"./86.png": 1301,
	"./87.png": 1884,
	"./88.png": 5483,
	"./89.png": 4354,
	"./crown.png": 826,
	"./unknown.png": 5349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;